import { render, staticRenderFns } from "./addCustomTemplate.vue?vue&type=template&id=9bb6c09c&scoped=true"
import script from "./addCustomTemplate.vue?vue&type=script&lang=js"
export * from "./addCustomTemplate.vue?vue&type=script&lang=js"
import style0 from "./addCustomTemplate.vue?vue&type=style&index=0&id=9bb6c09c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb6c09c",
  null
  
)

export default component.exports